import { UIKitSettingsBuilder } from "@cometchat/uikit-shared";
import { CometChatUIKit } from "@cometchat/chat-uikit-vue";
import { CometChat } from "@cometchat/chat-sdk-javascript";

let isInitialized = false;

export const initializeCometChat = async () => {
  if (isInitialized) {
    console.log("CometChat already initialized");
    return;
  }

  const UIKitSettings = new UIKitSettingsBuilder()
    .setAppId(process.env.VUE_APP_COMETCHAT_APP_ID)
    .setRegion(process.env.VUE_APP_COMETCHAT_REGION)
    .setAuthKey(process.env.VUE_APP_COMETCHAT_AUTH_KEY)
    .subscribePresenceForFriends()
    .build();

  try {
    await CometChatUIKit.init(UIKitSettings);
    console.log("CometChat successfully initialized");
    isInitialized = true;
  } catch (error) {
    console.error("CometChat initialization failed:", error);
    throw error;
  }
};

export const loginUser = async (userData) => {
  const userDetails = await fetchUserDetails(userData.uuid);
  if (!userDetails) {
    await createUser(userData)
  }

  CometChatUIKit.getLoggedinUser()
    .then((user) => {
      if (!user) {
        CometChatUIKit.login(userData.uuid)
          .then((user) => {
            console.log("Login Successful:", { user });
          })
          .catch(console.log);
      } else {
        if (user.uid !== userData.uuid) {
          console.log('user not match')
          CometChatUIKit.logout()
          CometChatUIKit.login(userData.uuid)
            .then((user) => {
              console.log("Login Successful:", { user });
            })
            .catch(console.log);
        }
        console.log("Already logged in:", { user });
      }
    })
    .catch(console.log);
};

export const initializeAndLoginCometChat = async (userData) => {
  try {
    await initializeCometChat();
    await loginUser(userData);
  } catch (error) {
    console.error("CometChat initialization or login failed:", error);
  }
};

export const initUser = async (uuid) => {
  try {
    await initializeCometChat();
    return new CometChat.User(uuid);
  } catch (error) {
    console.error("User initialization failed:", error);
  }
};

const fetchUserDetails = async (uid) => {
  const url = `https://${process.env.VUE_APP_COMETCHAT_APP_ID}.api-${process.env.VUE_APP_COMETCHAT_REGION}.cometchat.io/v3/users/${uid}`;
  const options = {
    method: "GET",
    headers: {
      'Content-Type': "application/json",
      'apiKey': process.env.VUE_APP_COMETCHAT_API_KEY,
    },
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Failed to fetch user details: ${response.statusText}`);
    }
    const userDetails = await response.json();
    console.log("User Details:", userDetails);
    return userDetails;
  } catch (error) {
    console.error("Error fetching user details:", error);
    return null;
  }
};

const createUser = async (userData) => {
  const url = `https://${process.env.VUE_APP_COMETCHAT_APP_ID}.api-${process.env.VUE_APP_COMETCHAT_REGION}.cometchat.io/v3/users`;
  const options = {
    method: "POST",
    headers: {
      'Content-Type': "application/json",
      'apiKey': process.env.VUE_APP_COMETCHAT_API_KEY,
    },
    body: JSON.stringify({
      uid: userData.uuid,
      name: userData.name,
      metadata: {
        "@private": {
          email: userData.email,
        },
      },
    }),
  };

  try {
    const response = await fetch(url, options);
    if (!response.ok) {
      throw new Error(`Failed to create user: ${response.statusText}`);
    }
    const createdUser = await response.json();
    console.log("User Created:", createdUser);
    return createdUser;
  } catch (error) {
    console.error("Error creating user:", error);
    return null;
  }
};
